export { default } from "./Navatar";
export { default as NavatarV2 } from "./v2/Navatar";
//# sourceMappingURL=index.js.map